import { useState, useEffect } from 'react';
import api from '@services/api';

function useToggle(toggle) {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    api.get(`/admin/feature_toggles/${toggle}`).then((response) => {
      setIsActive(response.data.active);
    });
  }, []);

  return isActive;
}

export default useToggle;
